import { useEffect } from "react";

import MUISelect from "@mui/material/Select";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Typography,
} from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

const Select = ({
  id,
  label,
  value,
  onChange,
  items,
  disabled,
  darkSelectedItems,
  includeNone,
  noneLabel,
  multiSelect,
  controlStyle,
  labelStyle,
  textStyle,
}) => {
  const { getLabel } = useLocalization();

  const handleChange = (newValue) => {
    onChange(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ paddingLeft: "6px", paddingRight: "6px" }}>
        <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
          {getLabel(label)}
        </Typography>
      </Box>
      <FormControl
        fullWidth
        size="small"
      >
        <MUISelect
          id={id}
          size="small"
          value={value === undefined || value === null ? "" : value}
          onChange={(e) => handleChange(e.target.value)}
          disabled={disabled}
          multiple={multiSelect}
          sx={{
            ...controlStyle,
            "& .MuiSelect-select": {
              padding: "6px",
              fontSize: "12px",
              ...textStyle,
            },
          }}
        >
          {includeNone ? (
            <MenuItem value="all">{noneLabel ? noneLabel : ""}</MenuItem>
          ) : null}
          {items && items.length > 0
            ? items.map((option) => (
                <MenuItem
                  key={option.id || option._id}
                  value={option.id || option._id}
                  sx={
                    darkSelectedItems
                      ? {
                          "&.Mui-selected": {
                            backgroundColor: (theme) =>
                              theme.palette.primary.main,
                            color: (theme) =>
                              theme.palette.primary.contrastText,
                          },
                          "&.Mui-selected:hover": {
                            backgroundColor: (theme) =>
                              theme.palette.primary.dark,
                          },
                        }
                      : undefined
                  }
                >
                  {option.name}
                </MenuItem>
              ))
            : null}
        </MUISelect>
      </FormControl>
    </Box>
  );
};

export default Select;
